import HeaderPage from "../../components/lines-managements/header/HeaderPage";
import PayoutsList from "../../components/affiliates/PayoutsList";

const payoutStatusFilterOptions = [
  { label: "Ne pritje", id: 0 },
  { label: "Aprovuar", id: 1 },
  { label: "Refuzuar", id: 3 }
];

const AffiliatePayouts: React.FC = () => {
  return (
    <>
      <HeaderPage
        hasFilter
        filterName="Statusi"
        filterSelctor="status"
        options={payoutStatusFilterOptions}
      />
      <PayoutsList />
    </>
  );
};

export default AffiliatePayouts;
